import { render } from "./CatalougeCategoryManager.vue?vue&type=template&id=2f0b360b"
import script from "./CatalougeCategoryManager.vue?vue&type=script&lang=js"
export * from "./CatalougeCategoryManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__